import { css } from '@repo/pandacss/styled-system/css';
import type { SpacingProp } from './types';

export const SPACING_PROP_VAR: Record<SpacingProp, string> = {
  margin: '--well-m',
  padding: '--well-p',
  marginTop: '--well-mt',
  marginBottom: '--well-mb',
  marginLeft: '--well-ml',
  marginRight: '--well-mr',
  paddingTop: '--well-pt',
  paddingBottom: '--well-pb',
  paddingLeft: '--well-pl',
  paddingRight: '--well-pr',
};

// Static panda class. Each spacing property reads from its base CSS variable,
// with a `md:` override that prefers `--*-md` and falls back to the base value.
// This lets `--wide` tokens apply only at md+ while normal tokens apply everywhere.
export const wellSpacingClass = css({
  // eslint-disable-next-line @pandacss/prefer-atomic-properties
  margin: 'var(--well-m)',
  // eslint-disable-next-line @pandacss/prefer-atomic-properties
  padding: 'var(--well-p)',
  marginTop: 'var(--well-mt)',
  marginBottom: 'var(--well-mb)',
  marginLeft: 'var(--well-ml)',
  marginRight: 'var(--well-mr)',
  paddingTop: 'var(--well-pt)',
  paddingBottom: 'var(--well-pb)',
  paddingLeft: 'var(--well-pl)',
  paddingRight: 'var(--well-pr)',
  md: {
    // eslint-disable-next-line @pandacss/prefer-atomic-properties
    margin: 'var(--well-m-md, var(--well-m))',
    // eslint-disable-next-line @pandacss/prefer-atomic-properties
    padding: 'var(--well-p-md, var(--well-p))',
    marginTop: 'var(--well-mt-md, var(--well-mt))',
    marginBottom: 'var(--well-mb-md, var(--well-mb))',
    marginLeft: 'var(--well-ml-md, var(--well-ml))',
    marginRight: 'var(--well-mr-md, var(--well-mr))',
    paddingTop: 'var(--well-pt-md, var(--well-pt))',
    paddingBottom: 'var(--well-pb-md, var(--well-pb))',
    paddingLeft: 'var(--well-pl-md, var(--well-pl))',
    paddingRight: 'var(--well-pr-md, var(--well-pr))',
  },
});
